import styles from './lottery-home.style';
import { Swiper, SwiperSlide } from 'swiper/react';
import { GrFormNext, GrFormPrevious } from 'react-icons/gr';
import { useRef } from 'react';
import { Navigation } from 'swiper/modules';
import TimeCountDown from 'components/Time-countdown/TimeCountDown';
import { RootState, useAppSelector } from 'cache/store';
import alertMsg from 'components/alert-message/alert-message';
import { useNavigate } from 'react-router-dom';
import { msgAuth } from 'constants/messageAlert';
interface Props {
    lotteryList: any[];
}
function TodayLotteryHome(props: Props) {
    const { lotteryList } = props;
    
    const btnPrevSlide = useRef<HTMLButtonElement>(null);
    const btnNextSlide = useRef<HTMLButtonElement>(null);
    const { isLogged } = useAppSelector((state: RootState) => state.auth);
    const navigate = useNavigate();

    const openGame = (ltId: number) => {
        if(!isLogged) {
            alertMsg(msgAuth.login);
            return;
        }
        navigate(`/lottery?ltId=${ltId}`);
    };

    return (
        <>
        <div className={styles.wrap}>
                <button ref={btnPrevSlide} className={`${styles.btnPrev} ${styles.btnNavigate}`}>
                    <GrFormPrevious size={40} />
                </button>
                <button ref={btnNextSlide} className={`${styles.btnNext} ${styles.btnNavigate}`}>
                    <GrFormNext size={40} />
                </button>
                <Swiper
                    spaceBetween={21}
                    slidesPerView={5}
                    modules={[Navigation]}
                    navigation={{
                        prevEl: btnPrevSlide.current,
                        nextEl: btnNextSlide.current,
                    }}
                >
                    {lotteryList.map((item) => (
                        <SwiperSlide key={item.lotteryid}>
                            <div className={styles.card} onClick={() => openGame(item.lotteryid)}>
                                <div className={styles.winnumber}>
                                    <div className={styles.issue}>
                                        <h6>{item.lotteryname}</h6>
                                        <p>{item.issue}</p>
                                    </div>
                                    <div className={styles.top}>
                                        <img src={require(`assets/images/icons-lt/${item.lotteryid}.png`)} alt="" />
                                    </div>
                                    {/* <p className={styles.textrs}>Giải đặc biệt</p> */}
                                    <div className={styles.result}>
                                        {item.listJackpost.length > 0 ? (
                                            item.listJackpost.map((num: number, index: number) => <div key={index}>{num}</div>)
                                        ) : (
                                            // list jackpost null
                                            <>
                                                <div>?</div>
                                                <div>?</div>
                                                <div>?</div>
                                                <div>?</div>
                                                <div>?</div>
                                            </>
                                        )}
                                    </div>
                                    <div className={styles.bottom}>
                                        <div className={styles.timecount}>
                                            <img src={require(`assets/images/icons/clock.png`)} alt="" />
                                            <TimeCountDown opentime={item.opentime} endtime={item.endtime} servertime={item.servertime} styleProps={{ fontSize: '16px' }} />
                                        </div>
                                        <div className={styles.btnbet}>
                                            <img src={require(`assets/images/icons/btn-bet.png`)} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </>
    );
}

export default TodayLotteryHome;
